// extracted by mini-css-extract-plugin
export default {"CardHeaderRow":"CardHeader_CardHeaderRow__HMxkx","CardIcon":"CardHeader_CardIcon__sCBOe","CardText":"CardHeader_CardText__1hYBv","ChevronIcon":"CardHeader_ChevronIcon__X2Cnl"};